import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProfileInterviewSession } from '../../virtual-interview/models/virtual-interview-model';
import { InterviewService } from '../../virtual-interview/services/interview.service';


@Component({
  selector: 'app-evaluatedinterview',
  templateUrl: './evaluatedinterview.component.html',
  styleUrls: ['./evaluatedinterview.component.css']
})
export class EvaluatedinterviewComponent implements OnInit {
  interviews: ProfileInterviewSession[] = [];
  isLoading: boolean = true;

  constructor(
    private interviewService: InterviewService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadCompletedInterviews();
  }

  loadCompletedInterviews() {
    this.isLoading = true;
    
    this.interviewService.getProfileInterviews().subscribe({
      next: (response) => {
        this.interviews = response;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('❌ Error loading interviews:', error);
        this.isLoading = false;
      }
    });
  }

  viewEvaluation(interview: ProfileInterviewSession) {
    
    this.router.navigate(['/profile/evaluated-interview-profiles'], {
      state: {
        sessionId: interview.sessionId,
        attemptIndex: 0
      }
    });
  }

  getAttemptText(index: number): string {
    const attempts = ['First', 'Second', 'Third', 'Fourth', 'Fifth'];
    return `${attempts[index] || (index + 1)} attempt`;
  }
}